// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearBubbleSpark = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 15',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.1411 4.14307C12.9009 4.38325 12.7097 4.66637 12.5766 4.9766C12.4436 4.66637 12.2524 4.38325 12.0122 4.14307C11.772 3.90289 11.4889 3.71166 11.1787 3.57863C11.4889 3.4456 11.772 3.25436 12.0122 3.01419C12.2524 2.77401 12.4436 2.49089 12.5766 2.18066C12.7097 2.49089 12.9009 2.77401 13.1411 3.01419C13.3812 3.25436 13.6644 3.4456 13.9746 3.57863C13.6644 3.71166 13.3812 3.90289 13.1411 4.14307Z',
      stroke: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.78328 5.56325C7.67476 5.96825 7.44982 6.33251 7.13632 6.61093C6.82282 6.88935 6.43453 7.06969 6.01954 7.12962C5.60456 7.18954 5.18112 7.12641 4.80166 6.94805C4.4222 6.76969 4.1034 6.48393 3.88474 6.12618C3.66608 5.76842 3.55718 5.35438 3.57151 4.93534C3.58584 4.5163 3.72278 4.11067 3.96537 3.76869C4.20796 3.4267 4.54554 3.1634 4.9363 3.01138C5.32705 2.85936 5.75382 2.82531 6.16374 2.91344L6.26793 2.93859L6.37074 2.96891C6.89404 3.13759 7.33249 3.50095 7.59541 3.98383C7.85832 4.46671 7.92558 5.03217 7.78328 5.56325Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.32664 10.1836C4.24539 10.4868 4.07715 10.7595 3.84269 10.9682C3.60822 11.1768 3.3178 11.3123 3.00725 11.3578C2.6967 11.4033 2.37962 11.3569 2.09514 11.2243C1.81065 11.0917 1.57122 10.8787 1.40638 10.6116C1.24155 10.3445 1.15853 10.035 1.16756 9.72126C1.17659 9.40753 1.27729 9.1033 1.45722 8.84612C1.63715 8.58895 1.88844 8.39009 2.18008 8.27408C2.47171 8.15806 2.79094 8.12998 3.09836 8.19329L3.19013 8.2151L3.28052 8.2421C3.66961 8.37125 3.99463 8.64421 4.1891 9.00512C4.38357 9.36603 4.43277 9.7876 4.32664 10.1836Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.7796 11.3486C11.6301 11.9067 11.3197 12.4084 10.8873 12.7915C10.4548 13.1746 9.91924 13.4221 9.34723 13.5032C8.77521 13.5843 8.19196 13.4955 7.67002 13.2478C7.14808 13.0001 6.71048 12.6044 6.41163 12.11C6.11278 11.6155 5.96588 11.0441 5.98919 10.4669C6.0125 9.88959 6.205 9.33191 6.54274 8.86317C6.88048 8.39444 7.34857 8.03532 7.88878 7.8305C8.429 7.62567 9.0175 7.58417 9.58112 7.71116L9.69604 7.73974L9.80985 7.77245C10.5365 7.9988 11.1473 8.4975 11.5145 9.16411C11.8817 9.83072 11.9767 10.6135 11.7796 11.3486Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearBubbleSpark };
